export default __webpack_public_path__ + "static/ramanSharma9-eb74c94b40fa971cc40c408bc38b00ea.jpg";